<script>
    // @ts-nocheck
    import {
        InputText,
        InputHidden,
        Select,
        TextArea,
        InputRadioSet,
        Row,
        SelectX as Select2
    } from '../UI'
    import {
        validateDoc,
        validarCp,
        validarTelefono,
        validateEmail,
    } from '$lib/utils'
    import dictionaries from '../../stores/dictionaries'
    export let data = {}
    export let inputs = null
    export let editable = true
    export let restricted = false
    export const valid = true
    export const dynamic = true
    let doctype = data.tipo_doc_dp || '2'
    $: allowedInputs = inputs instanceof Array ? inputs : []
    $: showAll = !(allowedInputs.length > 0)
    $: personaJuridica = data?.persona_jur_dp || false
    function allowInputs() {
        let args = Array.prototype.slice.call(arguments)
        return showAll || args.some((x) => allowedInputs.includes(x))
    }
    // $: options = !data.persona_jur_dp ? $dictionaries?.tipo_documento?.filter((x) => x.label !== "CUIT") : $dictionaries.tipo_documento;
    let options = [{ label: 'CUIT', value: '2' }]
    // $: currentIndexDocNro = data.persona_jur_dp ? 1 : options.findIndex(x => x.value === data?.tipo_doc_dp) >= 0 ? options.findIndex(x => x.value === data?.tipo_doc_dp) : 0;
    let exceptionMigrated = (_) => false
    function calcException() {
        exceptionMigrated = (o) =>
            editable &&
            ['1', 'True', 'true', true, 1].some(
                (x) => x === data?.precargado
            ) &&
            [null, '', undefined].includes(data[o]?.trim() || null) &&
            !!!data?.persona_jur_dp
    }
    calcException()
</script>

{#if allowInputs('persona_jur_dp', 'persona_hum_dp')}
    <Row justify="flex-start">
        <span on:click={calcException}>
            <InputRadioSet.Group
                alignOptions
                bind:value={data.persona_jur_dp}
                required
                disabled={!editable || restricted}
            >
                <InputRadioSet.Option
                    on:click={(_) => console.log('click')}
                    selected={!data.persona_jur_dp}
                    value={false}
                    label="Persona Humana"
                />
                <InputRadioSet.Option
                    on:click={(_) => console.log('click')}
                    value={true}
                    label="Persona Jurídica"
                />
            </InputRadioSet.Group>
        </span>
    </Row>
    <InputHidden name="persona_hum_dp" value={!data.persona_jur_dp} />
{/if}
{#if allowInputs('nombre_dp', 'apellido_dp')}
    <Row style="width: 100%;">
        {#if allowInputs('nombre_dp')}
            <InputText
                maxLength={35}
                required={!data.persona_jur_dp}
                disabled={!editable ||
                    !(restricted
                        ? exceptionMigrated('nombre_dp')
                        : !restricted)}
                name="nombre_dp"
                bind:value={data.nombre_dp}
                label="Nombre"
            />
        {/if}
        {#if allowInputs('apellido_dp')}
            <InputText
                maxLength={35}
                required={!data.persona_jur_dp}
                disabled={!editable ||
                    !(restricted
                        ? exceptionMigrated('nombre_dp')
                        : !restricted)}
                name="apellido_dp"
                bind:value={data.apellido_dp}
                label="Apellido"
            />
        {/if}
    </Row>
{/if}
{#if allowInputs('denominacion_dp')}
    <Row>
        <InputText
            maxLength={55}
            required={personaJuridica}
            disabled={!editable || restricted}
            name="denominacion_dp"
            bind:value={data.denominacion_dp}
            label="Denominación Social"
        />
    </Row>
{/if}
{#if allowInputs('tipo_doc_dp', 'no_doc_dp')}
    <Row>
        {#if allowInputs('tipo_doc_dp')}
            <Select
                required
                name="tipo_doc_dp"
                currentIndex={0}
                label="Tipo Documento"
                bind:value={doctype}
                disabled
                {options}
                placeholder="Seleccione una opción."
            />
        {/if}
        {#if allowInputs('no_doc_dp')}
            {#key doctype}
                <InputText
                    required
                    maxLength={11}
                    bind:value={data.no_doc_dp}
                    disabled={!editable || restricted}
                    errorMsg="Ingrese un Documento válido."
                    info="Ingrese un documento sin espacios ni puntos."
                    validation={validateDoc(doctype)}
                    name="no_doc_dp"
                    label="Documento"
                />
            {/key}
        {/if}
    </Row>
{/if}
{#if allowInputs('nombre_fantasia_dp')}
    <Row>
        <InputText
            maxLength={55}
            name="nombre_fantasia_dp"
            label="Nombre Fantasía"
            disabled={!editable}
            bind:value={data.nombre_fantasia_dp}
        />
    </Row>
{/if}
{#if allowInputs('actividad_principal_dp')}
    <Row>
        <InputText
            required
            maxLength={250}
            name="actividad_principal_dp"
            disabled={!editable}
            bind:value={data.actividad_principal_dp}
            label="Actividad Principal"
        />
    </Row>
{/if}
{#if allowInputs('domicilio_dp')}
    <Row>
        <InputText
            maxLength={100}
            required
            name="domicilio_dp"
            disabled={!editable}
            bind:value={data.domicilio_dp}
            label="Domicilio"
        />
    </Row>
{/if}
{#if allowInputs('provincia_dp')}
    <Row>
        <Select2
            label="Provincia"
            options={$dictionaries.provincias}
            name="provincia_dp"
            required
            bind:value={data.provincia_dp}
        />
    </Row>
{/if}
{#if allowInputs('localidad_dp', 'cp_dp', 'tel_dp')}
    <Row>
        {#if allowInputs('localidad_dp')}
            <InputText
                maxLength={55}
                required
                name="localidad_dp"
                disabled={!editable}
                bind:value={data.localidad_dp}
                label="Localidad"
            />
        {/if}
        {#if allowInputs('cp_dp')}
            <InputText
                required
                maxLength={8}
                errorMsg="Ingrese un Código Postal válido."
                info="El Código Postal puede contener letras y números."
                validation={(n) => typeof n === 'string' && validarCp(n)}
                name="cp_dp"
                disabled={!editable}
                bind:value={data.cp_dp}
                label="Código Postal"
            />
        {/if}
        {#if allowInputs('tel_dp')}
            <InputText
                required
                maxLength={18}
                errorMsg="Ingrese un Teléfono válido."
                info="El Teléfono debe cumplir con el formato 011122334455."
                name="tel_dp"
                disabled={!editable}
                bind:value={data.tel_dp}
                label="Teléfono"
                validation={validarTelefono}
            />
        {/if}
    </Row>
{/if}
{#if allowInputs('email_dp')}
    <Row>
        <InputText
            required
            maxLength={256}
            name="email_dp"
            disabled={!editable}
            bind:value={data.email_dp}
            label="Email"
            validation={validateEmail}
            errorMsg="Escriba un email valido."
        />
    </Row>
{/if}
<TextArea
    name="observaciones_dp"
    disabled={!editable}
    bind:value={data.observaciones_dp}
    label="Observaciones"
/>
